import './product-notification.scss';
import './product-notification-form.scss';

class ProductNotification {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-product-notification',
            overlaySelector: '[data-overlay="root"]',
            latAttr: 'data-lat',
            lngAttr: 'data-lng',
            locationInputID: 'product_notification_location'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$productNotification = $element;
        this.$overlayHandle = this.$productNotification.querySelector(this.settings.overlaySelector);
        this.googleAPIKey = googleMapsApiKey; // eslint-disable-line
    }

    initialize () {
        this.setEvents();
    }

    getCityByLatLng (lat, lng, callback) {
        const geocoder = new google.maps.Geocoder();  // eslint-disable-line

        geocoder.geocode({ location: { lat: lat, lng: lng } }).then((response) => {
            if (response.results[0]) {
                const address = response.results[0];

                let city, country, zipcode;

                address.address_components.forEach((component) => {
                    if (component.types.includes('locality')) {
                        city = component.long_name;
                    } else if (component.types.includes('country')) {
                        country = component.long_name;
                    } else if (component.types.includes('postal_code')) {
                        zipcode = component.long_name;
                    }
                });

                if (city && country && zipcode) {
                    const readableString = zipcode + ' ' + city + ', ' + country;

                    if (typeof callback === 'function') {
                        callback(readableString);
                    }
                }
            }
        });
    }

    setEvents () {
        if (!window.overlayInitialized) {
            window.addEventListener('overlay.loaded', (e) => {
                this.setLocation(e.detail.$store);
            });
        }
    }

    setLocation (eventDetails) {
        this.$productNotification = eventDetails.querySelector('[data-product-notification="root"]');
        const lat = parseFloat(this.$productNotification.getAttribute(this.settings.latAttr));
        const lng = parseFloat(this.$productNotification.getAttribute(this.settings.lngAttr));

        const setLocationString = (locationString) => {
            if (locationString !== '') {
                const $locationInput = document.getElementById(this.settings.locationInputID);

                if ($locationInput) {
                    $locationInput.value = locationString;
                }
            }
        };

        if (this.googleAPIKey !== '') {
            if (typeof google !== 'undefined') {
                this.getCityByLatLng(lat, lng, setLocationString);
            } else {
                const waitForGoogle = setInterval(() => {
                    if (typeof google !== 'undefined') {
                        clearInterval(waitForGoogle);
                        this.getCityByLatLng(lat, lng, setLocationString);
                    }
                }, 100);
            }
        }
    }
}

export { ProductNotification };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $productNotification = $context.querySelector('[data-product-notification="root"]');
        if ($productNotification) {
            const productNotification = new ProductNotification($productNotification);
            productNotification.initialize();
        }
    }
});
